var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoapPump = function SvgSoapPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.117 18.132.745-.089-.745.089Zm-.907-7.618.745-.09-.745.09Zm-9.327 7.618.745.088-.745-.088Zm.907-7.618-.745-.09.745.09ZM7.876 20h8.248v-1.5H7.876V20Zm9.986-1.957-.907-7.618-1.49.177.907 7.618 1.49-.177ZM14.224 8H9.776v1.5h4.448V8ZM7.628 18.22l.907-7.618-1.49-.177-.907 7.618 1.49.177ZM9.776 8a2.75 2.75 0 0 0-2.73 2.425l1.489.177A1.25 1.25 0 0 1 9.776 9.5V8Zm7.179 2.425A2.75 2.75 0 0 0 14.224 8v1.5a1.25 1.25 0 0 1 1.241 1.102l1.49-.177ZM16.124 20a1.75 1.75 0 0 0 1.738-1.957l-1.49.177a.25.25 0 0 1-.248.28V20Zm-8.248-1.5a.25.25 0 0 1-.248-.28l-1.49-.177A1.75 1.75 0 0 0 7.876 20v-1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.5 11 4.75h2l1.25 3.75M13.5 5.75H17",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSoapPump;